function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
var _ref =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  id: "Grocer_Logo_Orange",
  "data-name": "Grocer Logo Orange",
  transform: "translate(-64.131 -403.279)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_318",
  "data-name": "Path 318",
  d: "M550.877,571.016a8.343,8.343,0,0,1,.013,1.321,19.573,19.573,0,0,1-2.9,8.88,4.653,4.653,0,0,1-.766.9.725.725,0,0,1-1.13-.014,6.8,6.8,0,0,1-1.44-2.058,20.146,20.146,0,0,1-2.211-7.8,7.559,7.559,0,0,1,.345-2.954,3.681,3.681,0,0,1,3.551-2.642,4.979,4.979,0,0,1,2.17.33,3.664,3.664,0,0,1,2.161,2.724A7.662,7.662,0,0,1,550.877,571.016Zm-6.185.478a3.815,3.815,0,0,0,.08.535,1.97,1.97,0,0,0,1.429,1.507,1.8,1.8,0,0,0,1.829-.517,2.356,2.356,0,0,0,.23-2.907,1.862,1.862,0,0,0-2.6-.553A2.185,2.185,0,0,0,544.692,571.494Z",
  transform: "translate(-476.92 -157.602)",
  fill: "#757575"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_322",
  "data-name": "Path 322",
  d: "M509.161,408.291c.531-.591,1-1.167,1.529-1.686s1.1-.967,1.682-1.478a6.76,6.76,0,0,0-1.831,1.28c-.514.525-.984,1.091-1.515,1.687a7.123,7.123,0,0,0-2.568-2.359,13.044,13.044,0,0,1,2.474,2.506l-.03.118a8.425,8.425,0,0,1-1.03.055,4.38,4.38,0,0,1-2.88-1.392,5.727,5.727,0,0,1-1.531-2.637c-.048-.185-.053-.338.2-.343a5.446,5.446,0,0,1,4.875,2.308,3.2,3.2,0,0,1,.3.579c.081.188.135.388.226.653a4.589,4.589,0,0,1,1.042-2.123,6.583,6.583,0,0,1,4.425-2.166c.308-.032.622,0,.932-.014s.33.142.263.394A6.862,6.862,0,0,1,514.2,406.5a5.591,5.591,0,0,1-3.232,1.919A3.536,3.536,0,0,1,509.161,408.291Z",
  transform: "translate(-439.305)",
  fill: "#757575"
}));
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    viewBox: "0 0 12.323 21.497"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/about-us-menu-icon.b7af4e1c.svg";
export { SvgComponent as ReactComponent };